import "./Referrals.module.css";
import Header from "@/reusable_sections/Header";
import CollaborativeLiaison from "./sections/CollaborativeLiaison";
import ProfessionalReferralForm from "./sections/ProfessionalReferralForm";
import DocumentationSamples from "./sections/DocumentationSamples";
import Footer from "@/reusable_sections/Footer";
export default function ReferralsPage() {
  return <div>
      <Header />
      <CollaborativeLiaison />
      <ProfessionalReferralForm />
      <DocumentationSamples />
      <Footer />
    </div>;
}